import { QuestionBase } from './question-base';

export class SelectionListQuestion extends QuestionBase<string[]> {
  controlType = 'selection-list';
}
